/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * ChangHeon Yoo (chyoo@rsupport.com)
 *
 * @description
 *
 * @created at Fri Aug 09 2024
 **/

import { Column, Icon, Row, Typography } from "@/frameworks/designStuff/components";
import { _T } from "@rfice/language";

import { Avatar } from "@/frameworks/core/components";
import { colors } from "@/frameworks/core/styles";

export default function GroupCallParticipatedUserList({
	userList
}: {
	userList: WebServices.GroupCall.Detail.Data["callUsers"];
}) {
	return (
		<Column style={{ paddingTop: "25px" }} gap={20}>
			<Column gap={20}>
				<Typography typoSize="Title3" typoColor="neutral_60_100">
					{_T("참석자")}
				</Typography>
				<Typography typoSize="Title1_B" typoColor="neutral_70_100">
					{_T("{{count}}명", { count: userList.length })}
				</Typography>
			</Column>
			<Column gap={12}>
				{userList.map((user) => (
					<CallUser key={user?.id} userInfo={user} />
				))}
			</Column>
		</Column>
	);
}

function CallUser({ userInfo }: { userInfo: WebServices.GroupCall.Detail.Data["callUsers"][number] }) {
	return (
		<Row gap={6} verticalAlign="center">
			{["HANGUP_NO_RESPONSE", "REJECTED"].includes(userInfo.callUserStatus) && (
				<Icon name="CallUnanswered24" fill={colors.warning_50_100} />
			)}
			<Avatar id={userInfo.id ?? ""} kind={"people_28"} />
			<Typography typoSize="Body3_MD">{userInfo.name}</Typography>
		</Row>
	);
}
